module.exports = __webpack_public_path__ + "assets/icon_dessert.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icon_dessert.png
 ** module id = 114
 ** module chunks = 1
 **/